import axios from 'axios'
import i18n from '../plugins/i18n'

export default {
  search(filters) {
    let filter = ''

    for (let field in filters) {
      filter += `${field}=${filters[field]}&`
    }

    return axios.get(`${i18n.locale}/api/public/search/?${filter}`)
  },
  getNpa(id) {
    return axios.get(`${i18n.locale}/api/public/search/npa/${id}`)
  },
  addNpaComment(id, data) {
    return axios.post(`${i18n.locale}/api/npaComment/${id}/add`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  editNpaComment(id, data) {
    return axios.post(`${i18n.locale}/api/npaComment/edit/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  deleteCommentFile(id) {
    return axios.get(`${i18n.locale}/api/npaComment/deleteFile/${id}`)
  },
  addNpaCommentAnswer(id, data) {
    return axios.post(`${i18n.locale}/api/npaCommentAnswer/add/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  like(id, data) {
    return axios.post(`${i18n.locale}/api/npaComment/${id}/like`, data)
  },
  sendComplaint(id, data) {
    return axios.post(`${i18n.locale}/api/npaComment/${id}/complaint`, data)
  }
}
